module.exports = __webpack_public_path__ + "static/media/boxTruck.9b39a500.svg";